import React, { Component } from 'react'
import { TextButton, IconType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import styles from './style.scss';

export default class ImportUserButton extends Component {
  
    render() {
        
        const { text, openImportUserDialog } = this.props;

        return (
            <div
                className={classNames(styles.importButtonWrapper)}
            >
                <TextButton
                    dataCy='btn-import-user'
                    text={text}
                    onClick={openImportUserDialog}
                    iconType={IconType.addFolder}
                    linkClassName={classNames(styles.importLinkWrapper)}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/users/directoryUsers/importUserButton/importButton.jsx